import React, { type FC, memo, useMemo } from "react";
import { AppRoutes } from "@domain/routing/routeConstants";
import { useLocation } from "react-router-dom";
import { InvoicingPaths } from "@invoicing/types";
import { FormattedMessage } from "react-intl";
import { ModuleNav, type NavItem } from "./ModuleNav";

const ModuleInvoicingLinksImpl: FC = () => {
    const { pathname = "" } = useLocation();

    const linkFormats = AppRoutes.invoicing + "/" + InvoicingPaths.FORMATS;
    const linkLITemplates = AppRoutes.invoicing + "/" + InvoicingPaths.LINE_ITEMS_TEMPLATES;
    const linkPTTemplates = AppRoutes.invoicing + "/" + InvoicingPaths.PAYMENT_TEMPLATES;

    const selectedKeys = useMemo(() => [pathname], [pathname]);
    const items = useMemo<NavItem[]>(
        () => [
            {
                key: AppRoutes.invoicing,
                to: AppRoutes.invoicing,
                label: <FormattedMessage id="app.invoice.invoicesList" />,
            },
            { key: linkFormats, to: linkFormats, label: "Formats" },
            {
                key: "Templates",
                label: <FormattedMessage id="app.titles.templates" />,
                children: [
                    {
                        key: linkLITemplates,
                        to: linkLITemplates,
                        label: <FormattedMessage id="app.invoice.invoiceLineItemTemplates" />,
                    },
                    {
                        key: linkPTTemplates,
                        to: linkPTTemplates,
                        label: <FormattedMessage id="app.invoice.invoicePaymentTemplates" />,
                    },
                ],
            },
        ],
        [linkFormats, linkLITemplates, linkPTTemplates],
    );

    return <ModuleNav selectedKeys={selectedKeys} items={items} />;
};

export const ModuleInvoicingLinks = memo(ModuleInvoicingLinksImpl);
